export default "__VITE_ASSET__7fad8f71__"